import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import clsx from 'clsx';
import AttachmentIcon from '@assets/icons/messages/attachment.svg';

interface RecordType {
  messageGroupId: string;
  allRead: boolean;
  [key: string]: any;
}

interface RenderLinkComponentProps {
  value: any;
  record: RecordType;
}

type Column = {
  dataIndex?: string;
  title?: string;
  width?: string;
  key?: string;
  className?: string;
  render?: (value: any, options: { record: RecordType }) => ReactNode;
};

const columns: Column[] = [
  {
    title: 'threads.table.columns.date',
    width: '180px',
    dataIndex: 'lastDateCreated',
    render: renderLink(({ value }) => formatDate(value)),
  },
  {
    title: 'threads.table.columns.subject',
    dataIndex: 'subject',
    render: renderLink(),
  },
  {
    key: 'attachment',
    className: '!border-l-0',
    width: '59px',
    dataIndex: 'hasAttachments',
    render: renderAttachments(),
  },
];

function renderLink(Component?: (props: RenderLinkComponentProps) => ReactNode): (value: any, options: { record: RecordType }) => ReactNode {
  return function (value: any, { record }: { record: RecordType }) {
    const className = clsx({ 'text-[#45454a]': !record.allRead });
    const url = `/messages/${record.messageGroupId}`;
    const displayValue = value === undefined || value === null ? '(no-subject)' : value;

    if (Component) {
      return (
        <Link className={clsx('text-[#616164] no-underline hover:text-underline', className)} to={url}>
          <Component value={displayValue} record={record} />
        </Link>
      );
    } else {
      return (
        <Link className={clsx('text-[#616164] no-underline hover:text-underline', className)} to={url}>
          {displayValue}
        </Link>
      );
    }
  };
}

function renderAttachments(): (value: boolean, options: { record: RecordType }) => ReactNode {
  return function (value: boolean) {
    if (value) return <AttachmentIcon className='block mx-auto h-3 text-[#6b6b70] w-6' />;
    return null;
  };
}

const formatDate = (date: string | Date) => dayjs(date).format('DD/MM/YYYY');

export default columns;
